import { useStore } from "@/context/StoreContext";
import { ProductCard } from "@/components/ProductCard";
import { Reveal } from "@/components/Reveal";

export const SelectedThree = () => {
  const { site, products } = useStore();
  const [a, b, c, ...rest] = products;
  return (
    <section id="edit" data-testid="selected-three-section" className="bg-ivory py-20 lg:py-32 scroll-mt-24">
      <div className="container-rh">
        <Reveal className="grid lg:grid-cols-12 gap-6 items-end mb-12 lg:mb-20">
          <div className="lg:col-span-7">
            <p className="eyebrow text-berry mb-5">Launch collection · {String(products.length).padStart(2, "0")} pieces</p>
            <h2 className="font-display font-medium text-[44px] sm:text-6xl lg:text-[76px] leading-[0.95]">{site.edit.heading}</h2>
          </div>
          <p className="lg:col-span-4 lg:col-start-9 text-[18px] leading-relaxed text-plum/75">{site.edit.subheading}</p>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-x-12 gap-y-16">
          {a && <Reveal className={b ? "lg:col-span-7" : "lg:col-span-8 lg:col-start-3"}><ProductCard p={a} index={0} layout="feature" /></Reveal>}
          {b && (
            <Reveal delay={0.12} className="lg:col-span-5 lg:pt-44 relative">
              <div aria-hidden className="hidden lg:block absolute -right-6 top-24 w-2/3 h-72 rounded-[28px] bg-blush -z-0" />
              <div className="relative"><ProductCard p={b} index={1} /></div>
            </Reveal>
          )}
          {c && <Reveal className="lg:col-span-12"><ProductCard p={c} index={2} layout="band" /></Reveal>}
        </div>

        {rest.length > 0 && (
          <div className="mt-16 lg:mt-24 grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-14">
            {rest.map((p, i) => <Reveal key={p.id} delay={i * 0.08}><ProductCard p={p} index={i + 3} /></Reveal>)}
          </div>
        )}
      </div>
    </section>
  );
};
